import React, { Component } from "react";
import { connect } from "react-redux";
import { Form as RForm, FormGroup, Label, Input, Button, FormText} from "reactstrap";
import { isEqual, has, isArray } from 'lodash';
import { FaCircleNotch } from 'react-icons/fa';
import Upload from '../Layout/Upload';
import Actions from "../../../Actions";
import { dropdownItems } from "../../../Utilities/Common";
import Permissions from "../../../Utilities/Permissions";
import API from "../../../Configs";
import * as Helpers from '../../../Utilities/Common';

class Form extends Component{
    constructor(props){
        super(props);
        this.permissions = new Permissions(props.permissions);
        const { type = "", location = "", locationMeta = "", status = "", assigned_to = "", subLocation = "", subLocations = [], problem = "", priority = 0, HS = 0, comment = "", image = "", created_at = "", created_by = "", creation_timestamp = "", updated_at = "" } = props.data;
        this.state = {type,location,locationMeta,status,assigned_to,subLocation,subLocations,problem,priority,HS,comment,image,created_at,created_by, creation_timestamp, updated_at};
    }

    loadUsers = () => {
        const { token, userStore, getUsers} = this.props;
        const query = { page:1, sort: 'name', order: 'asc', per_page: 1000};
        if(!isEqual(userStore.query,query)){
            getUsers(token,query,false);
        }
    }

    loadLocations = () => {
        const { token, locationStore, getLocations } = this.props;
        const query = { page:1, sort: 'name', order: 'asc', per_page: 1000};
        if(!isEqual(locationStore.query,query)){
            getLocations(token,query,false);
        }
    }

    loadTypes = () => {
        const { token, typeStore, getTypes } = this.props;
        const query = { page:1, sort: 'name', order: 'asc', per_page: 1000};
        if(!isEqual(typeStore.query,query)){
            getTypes(token,query,false);
        }
    }

    componentDidMount(){
        this.loadLocations();
        this.loadTypes();
        this.loadUsers();
        const { locationStore: { locations } }  = this.props;
        const { location, subLocations: old_subLocations } = this.state;
        const { sub_locations: new_subLocations = [] } = has(locations,location) ? locations[location]:{};
        if(!isEqual(old_subLocations, new_subLocations)){
            this.setState((state) => ({...state, subLocations: new_subLocations}));
        }
    }

    setField = (endpoint, option, type = 0) => {
        Helpers.setField(endpoint, option, type, (dataObj) => {
            
            if(endpoint === "location"){
                const { locationStore: { locations } } = this.props;
                dataObj.subLocations = locations[option.target.value].sub_locations;
            }

            if(endpoint === "assigned_to"){
                dataObj.status = 2;
            }

            this.setState((state) => ({...state,...dataObj}));
        });
    }

    save = (event) => {
        event.preventDefault();
        const { persist, token, permissions, id = '' } = this.props;
        persist(token, this.state, permissions, id);
    }

    render = () => {
        const { blockedField } = this.permissions;
        const { type, location, locationMeta, status, assigned_to, subLocation, problem, priority, HS, comment, subLocations, image, created_at, created_by, creation_timestamp, updated_at } = this.state;
        const { jobStore: { jobSubmitted } ,typeStore: { types, typesMeta: { data: typesOrder }}, userStore: { users, usersMeta: { data: usersOrder} }, locationStore: {locations, locationsMeta: { data: locationsOrder } }, id = false} = this.props;
        const {STATUSES: statuses, STATUSES_ORDER: status_order} = API;
        const method = !id ? 'post': 'put';
        return (
                <RForm>
                    { has(users,created_by)? 
                    <div className="mb-2">
                        <FormGroup className="mb-0">
                            <Label className="mb-0">
                                <strong>Created by:</strong> { users[created_by].name }
                            </Label>
                        </FormGroup>
                        <FormGroup className="mb-0">
                            <Label className="mb-0">
                                <strong>Created:</strong> { creation_timestamp }
                            </Label>
                        </FormGroup>
                        <FormGroup className="mb-0">
                            <Label className="mb-0">
                                <strong>Updated:</strong> { updated_at }
                            </Label>
                        </FormGroup>
                        <FormGroup className="mb-0">
                            <Label className="mb-0">
                                <strong>Age:</strong> { created_at }
                            </Label>
                        </FormGroup>
                    </div>
                    :''}
                    <FormGroup>
                        <Label>
                            Job Type*
                        </Label>
                        <Input onChange={(value) => this.setField("type",value)} value={type} type="select">{dropdownItems(types, "Select", typesOrder)}</Input>
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Location*
                        </Label>
                        <Input onChange={(value) => this.setField("location",value)} value={location} type="select">{dropdownItems(locations, "Select", locationsOrder)}</Input>
                    </FormGroup>
                    {isArray(subLocations) && subLocations.length > 0 && 
                        <FormGroup>
                            <Label>
                                Sub Location*
                            </Label>
                            <Input onChange={(value) => this.setField("subLocation",value)} value={subLocation} type="select">{dropdownItems(subLocations)}</Input>
                        </FormGroup>
                    }
                    <FormGroup>
                        <Label>
                            Location (If not listed above)
                        </Label>                            
                        <Input onChange={(value) => this.setField("locationMeta",value)} value={locationMeta} placeholder="Location Extra Information"/>                            
                    </FormGroup>
                    <Upload onChange={(data) => this.setState((state) => ({ ...state, image: data }))} image={image}/>
                    <FormGroup>
                        <Label>
                            Problem*
                        </Label>
                        <Input onChange={(value) => this.setField("problem",value)} type="textarea" placeholder="Problem" rows="4" value={problem}/>
                    </FormGroup>
                    {!blockedField("priority","jobs",method) ? 
                        <FormGroup check>
                            <Label check>
                            <Input type="checkbox" onChange={(value) => this.setField("priority",value,1)} checked={priority === 1 ? true : false}/>
                                High Priority
                            </Label>
                            <br/>                                
                        </FormGroup>
                    :null}
                    <FormGroup check>
                        <Label check>
                        <Input type="checkbox" onChange={(value) => this.setField("HS",value,1)} checked={HS === 1 ? true : false}/>  {' '}
                            H&S
                        </Label>
                        <br/><br/>
                    </FormGroup>
                    {!blockedField("assigned_to","jobs",method) ?
                    <FormGroup>
                        <Label>
                            Assigned To
                        </Label>
                        <Input type="select" onChange={(value) => {this.setField("assigned_to",value);this.setState({status: 2})}} value={assigned_to}>{dropdownItems(users, "Select", usersOrder)}</Input>                            
                    </FormGroup>
                    :null}
                    {!blockedField("status","jobs",method) ?
                    <FormGroup >
                        <Label>
                            Status
                        </Label>
                        <Input type="select" onChange={(value) => this.setField("status",value)} value={status}>{dropdownItems(statuses, "Select", status_order)}</Input>
                    </FormGroup>
                    :null}
                    { id ?
                    <React.Fragment>
                        <FormGroup>
                            <Label>
                                Comment
                            </Label>
                            <Input type="textarea" onChange={(value) => this.setField("comment",value)} placeholder="Comment" rows="4" value={comment}/>
                        </FormGroup>
                        <FormGroup>
                            <FormText color="muted">* Required Field</FormText>
                        </FormGroup>
                    </React.Fragment>
                    : null}
                    <FormGroup>
                            <Button block disabled={jobSubmitted} onClick={this.save} color="success" kind="squared">
                                {jobSubmitted ? <FaCircleNotch className="icon-spin" style={{marginRight: '5px', verticalAlign:'text-bottom'}} />:false }
                                { id ? "Update": "Add" }
                            </Button>                           
                    </FormGroup>
                </RForm>
        );
    }
}

const mapStateToProps = (state) => ({
    permissions: state.auth.permissions,
    token: state.auth.token,
    typeStore: state.typeStore,
    locationStore: state.locationStore,
    userStore: state.userStore,
    jobStore: state.jobStore,
    companyStore: state.companyStore,
});

const { types, locations, users, companies } = Actions;

export default connect(mapStateToProps, {...types, ...locations, ...users, ...companies})(Form);


// WEBPACK FOOTER //
// ./src/Components/App/Jobs/Form.js